<template>
	<div class="container">
		<div class="row">
			<div class="col-12">
				<h1>Control Panel</h1>
				<p v-if="!current_user.admin" class="border-da beware p-5 h4">
					<b><i class="fa fa-warning"></i> Admins Only!!</b>
				</p>
			</div>
		</div>
		<div v-if="current_user.admin" class="row">
			<div class="col-12 p-3"><hr>
				<b @click="g8_poems" class="btn border-da mr-2">Poems</b>
				<b @click="g8_users" class="btn border-da">Users</b><hr>
			</div>
			<div class="col-12">
				<table v-if="view_poems==true" class="table table-striped table-bordered text-da">
					<thead class="sticky-top">
						<tr style="background-color: rgba(0, 0, 0, 0.05);">
							<th colspan=3 class="p-3">
								<input type="text" maxlength=8 placeholder="Poem search" v-model="search_poem" class="form-control">
							</th>
						</tr>
						<tr><!--250820 To add Filterby: </>name,[likes,comments].length; -->
							<th>
								Poems
								<span class="border-da px-1 ml-2 rounded">{{poems.length}}</span>
								<router-link to="/admin/add-poem" class="border-da rounded px-1 ml-2"><i class="fa fa-plus text-da"></i></router-link>
							</th><th>Likes</th><th>Comments</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="poem in poems" :key="poem._id" v-if="(search_poem.length<=0) || (search_poem.length>0 && poem.heading.toLowerCase().includes(search_poem.toLowerCase()))">
							<td>
								<h6 @click="edit_poem(poem)" class="col-10">{{poem.heading}}</h6>
							</td>
							<td>
								<h6 class="">{{poem.likes.length}}</h6>
							</td>
							<td>
								<h6 class="">{{poem.comments.length}}</h6>
							</td>
						</tr>
					</tbody>
				</table><!--End Poem List Table-->

				<table v-if="users.length && view_users==true" class="table table-striped table-bordered text-da">
					<thead>
						<tr style="background-color: rgba(0, 0, 0, 0.05);">
							<th colspan=3 class="p-3">
								<input type="text" maxlength=8 placeholder="Name search" v-model="search_user" class="form-control">
							</th>
						</tr>
						<tr>
							<th>Username</th><th>Site Access</th><th>User Accounts <span class="border-da px-1 rounded">{{users.length}}</span></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="user in users" :key="user._id" v-if="(search_user.length<=0) || (search_user.length>0 && user.name.toLowerCase().includes(search_user.toLowerCase()))">
							<td>
								<i :class="{ 'fa fa-user-circle-o': user.admin, 'fa fa-user': !user.admin }"></i> {{user.name}}
							</td>
							<td>
								<i @click="toggle_access(user._id, user.admin)" :class="{ 'fa fa-toggle-on': user.access, 'fa fa-toggle-off': !user.access }" :id=user._id></i>
							</td>
							<td>
								<i class="fa fa-user-times"></i>
							</td>
						</tr>
					</tbody>
				</table><!--End Users List Table-->
			</div><!--End Col-12-->
		</div><!--End Row-->
	</div><!--End Container-->
</template>

<script>
  import axios from 'axios';
  const token = window.localStorage.getItem('Bearer');

  export default {
  	data: ()=>({
  		view_poems: false,
	  	view_users: false,
	  	search_poem: '',
	  	search_user: '',
	  	tog_on: false,
	  	tog_off: false,
  	}),
    computed: {
			current_user() {
				return this.$store.getters.fetchUser;
			},
      users() {
        return this.$store.getters.fetchUsers;
      },
      poems() {
        return this.$store.getters.fetchPoems;
      }
    },
		mounted() {
			this.$store.dispatch("fetchUser");
		},
    methods: {
    	g8_poems(){
    		if(this.view_poems==true)return;
				this.$store.dispatch("fetchPoems");
        this.view_poems=true;
				this.view_users=false;
    	},
    	g8_users(){
    		if(this.view_users==true)return;
	      return axios({
	        method: 'get',
	        url: '../../api/users',
	        headers: {
	          'Authorization': `Bearer ${token}`,
	          'Content-Type': 'application/json',
	        },
	      })
	      .then((res)=>{
	        this.$store.commit('USERS', res.data.users);
	        this.view_users=true;
	        this.view_poems=false;
	      })
	      .catch(()=>{
	      	console.log("Users can't get!!")
	      });
  		},
  		edit_poem(poem){
  			if(this.current_user.admin){
        	this.$store.commit('POEM', poem);
        	this.$router.push({name: 'EditPoem'});
      	} return;
  		},
  		toggle_access(user_id, admin){
  			if(admin)return;
  			var u2 = document.getElementById(user_id);
	      return axios({
	        method: 'patch',
					data: {
						access: true,
						uid: user_id
					},
	        url: '../../api/auth',
	        headers: {
	          'Authorization': `Bearer ${token}`,
	          'Content-Type': 'application/json',
	        },
	      })
	      .then((res)=>{
	      	if(res.data.access==true){
	      		u2.className='fa fa-toggle-on';
	      	} else {
	      		u2.className='fa fa-toggle-off';
    			}
	      })
	      .catch(()=>{
	      });
      }
    }
  }
</script>